module.exports = require("lodash/thru");